export const EMAIL_VERIFICATION_STATUS = 'EMAIL_VERIFICATION_STATUS';
export const EMAIL_VERIFICATION_STATUS_VERIFIED = 'verified';

